import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAPI } from '../../api';
import PageSection from '../../components/PageSection';
import PropEditor from '../../components/PropEditor';
import RawJsonDisplay from '../../components/RawJsonDisplay';
import { WorkspaceInfo } from 'types';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

const WorkspaceContainer = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const { workspaceID } = useParams();

	const [workspace, setWorkspace] = useState<WorkspaceInfo | null>(null);

	const loadWorkspace = () => {
		api.get<WorkspaceInfo>(`${ctx?.apiBaseTenant}/workspaces/${workspaceID}`)
		.then(json => setWorkspace(json))
		.catch(() => setWorkspace(null));
	};

	const saveWorkspace = () => {
		api.put(`${ctx?.apiBaseTenant}/workspaces/${workspaceID}`, { name: workspace?.name })
		.then(loadWorkspace)
		.then(ctx?.reload);
	}

	useEffect(() => {
		loadWorkspace();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ctx?.tenantID, workspaceID]);

	return (
		<div>
			<PageSection title={`Workspace: ${workspace?.name ?? workspaceID}`} level={2} />

			<PageSection borderEnd={true}>
				<OrgContextLink to="/settings/workspaces">&#x25c0; Back to Workspaces</OrgContextLink>
			</PageSection>

			<PageSection title="Workspace Info">
				<PropEditor<WorkspaceInfo | null>
					object={workspace}
					onChange={(obj) => setWorkspace(obj)}
					props={[
						{ label: 'Name', key: 'name' },
						{ label: 'ID', key: 'id', disabled: true },
						{ label: 'Tenant ID', key: 'tenantID', disabled: true }
					]}
					tools={[
						() => (<button type="button" onClick={saveWorkspace}>Save Workspace</button>)
					]}
				/>
			</PageSection>

			<PageSection title="Raw">
				<RawJsonDisplay data={workspace} />
			</PageSection>
		</div>
	);
};

export default WorkspaceContainer;
